// extracted by mini-css-extract-plugin
export default {"elementContainer":"style_elementContainer__BuUnP","removeElement":"style_removeElement__7hORA"};